// @flow
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import SnackBar from '@justpark/ui/src/components/SnackBar';
import { hideSnackbar } from '../stores/snackbar';

import '../../static/scss/components/connectedSnackBar.scss';

const ConnectedSnackBar = () => {
  const id = useSelector(state => state.snackbar.id);
  const message = useSelector(state => state.snackbar.message);

  const dispatch = useDispatch();

  const baseClass = 'c-connected-snackbar';

  useEffect(
    () => {
      if (!id) {
        return () => {};
      }

      const timeout = window.setTimeout(() => {
        dispatch(hideSnackbar());
      }, 10000);

      return () => {
        window.clearTimeout(timeout);
      };
    },
    [id, dispatch]
  );

  return (
    <TransitionGroup>
      {message ? (
        <CSSTransition
          classNames={baseClass}
          key={id}
          timeout={{ enter: 375, exit: 180 }}
        >
          <div className={baseClass} key={id}>
            <SnackBar message={message} />
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
};

export default ConnectedSnackBar;
